// extracted by mini-css-extract-plugin
export var activeDot = "_25-c";
export var buttonContainer = "_25-9";
export var channelButton = "_25-a";
export var clickable = "_25-d";
export var content = "_25-0";
export var contentFull = "_25-2";
export var contentThird = "_25-1";
export var contentWrapper = "_25-7";
export var description = "_25-5";
export var heightShort = "_25-f";
export var image = "_25-3";
export var imageContainer = "_25-4";
export var selectButton = "_25-e";
export var spinnerContainer = "_25-b";
export var titleContent = "_25-8";
export var titleWrapper = "_25-6";